import FontAwesomeIcon from 'react-fontawesome';
import { useTranslation } from 'react-i18next';

const Error: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className='error'>
            <div className='error-message'>{t('error')}</div>
            <FontAwesomeIcon name='exclamation-circle' className='warning-icon' />
        </div>
    );
};

export default Error;
